import { useRef, useState } from "react";

export function useAlert() {
  const [showAlert, setShowAlert] = useState(false);
  const onClose = () => setShowAlert(false);
  const cancelRef = useRef();

  return { onClose, showAlert, cancelRef, setShowAlert };
}
